import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type InvoiceStopperRule } from '../useQueryInvoiceStopperRules';

/**
 * Fetches the invoice stopper rule with the given stopperRuleId.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Invoice/operation/get_invoice_process_stopper_rule_vadmin_invoice_stopper_rule__stopper_rule_id__get
 */
export const fetchInvoiceStopperRule = async (stopperRuleId: UUID) => {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.INVOICE_REPROCESSING.GET_STOPPER_RULE(stopperRuleId), {})
      .json<InvoiceStopperRule>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error fetching invoice stopper rule',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 404: {
          errorMessage = i18n.t(($) => $.fetchInvoiceStopperRule.error404, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.fetchInvoiceStopperRule.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
